import { IUsersOptionsFilters } from "src/@types/stores";
import { Tags } from "../../enum/tags";
import { apiSlice } from "../http";
import { ISelectOptions } from "src/@types/select";

export const storeInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoresOptions: builder.query<ISelectOptions, void>({
      query: () => ({
        url: `/store/options/store`,
        method: "GET",
      }),
      providesTags: [Tags.OPTIONS_STORE],
    }),
    getAnalystsOptions: builder.query<
      ISelectOptions,
      IUsersOptionsFilters | void
    >({
      query: (filters) => {
        const params = new URLSearchParams(
          filters as unknown as Record<string, string>
        );
        return {
          url: `/store/options/responsibles?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.OPTIONS_RESPONSIBLE],
    }),
    getRegionalStoresOptions: builder.query<ISelectOptions, void>({
      query: () => ({
        url: `/store/options/regional`,
        method: "GET",
      }),
      providesTags: [Tags.OPTIONS_REGIONAL],
    }),
    getRegionalResponsible: builder.query<ISelectOptions, void>({
      query: () => ({
        url: `/store/options/regional-responsible`,
        method: "GET",
      }),
      providesTags: [Tags.OPTIONS_RESPONSIBLE],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetStoresOptionsQuery,
  useGetAnalystsOptionsQuery,
  useGetRegionalStoresOptionsQuery,
  useGetRegionalResponsibleQuery,
} = storeInformations;
